import { render } from "./CustomerDocumentsView.vue?vue&type=template&id=341a741e&scoped=true&ts=true&lang=pug"
import script from "./CustomerDocumentsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDocumentsView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDocumentsView.vue?vue&type=style&index=0&id=341a741e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341a741e"]])

export default __exports__